import script from "./HomeProductsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeProductsEditor.vue?vue&type=script&setup=true&lang=js"

import "./HomeProductsEditor.vue?vue&type=style&index=0&id=be8390ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be8390ce"]])

export default __exports__